export const FireContractAddress = '0xEb163D02b6431Cf3B83aBaa99b4b9942A993F8F5';
export const EarthContractAddress = '0xe33e2fE65aC84241013A968b157c00c6D5e41D43';
export const WaterContractAddress = '0xeBDe039113913C46fA4094EAff566D82DD49566B';
export const MagicContractAddress = '0xa2B8BBa841297597bb5E410761150Cb53949bfCa';